import { Box } from '@lifeomic/chroma-react/components/Box';
import { defineMessages, useIntl } from 'react-intl';
import { DotLoader } from '@lifeomic/chroma-react/components/DotLoader';
import { makeStyles } from '@lifeomic/chroma-react/styles';
import { TextField } from '@lifeomic/chroma-react/components/TextField';
import clsx from 'clsx';
import React from 'react';

const messages = defineMessages({
  placeholder: {
    id: 'phc-web-toolkit.components.autoSuggest.autoSuggestInput.placeholder',
    defaultMessage: 'Search...',
  },
});

const useStyles = makeStyles(() => ({
  root: {
    position: 'relative',
  },
  input: {
    width: '100%',
  },
  loader: {
    position: 'absolute',
    top: 6,
    right: 6,
  },
  loaderWithLabel: {
    top: 34,
    right: 10,
  },
}));

export interface AutoSuggestInputProps {
  disabled?: boolean;
  errorMessage?: string;
  fullWidth?: boolean;
  helperText?: string;
  inputProps?: any;
  isLoading?: boolean;
  label?: string;
  placeholder?: string;
  autoFocus?: boolean;
}

export const AutoSuggestInput: React.FC<AutoSuggestInputProps> = ({
  disabled,
  errorMessage = '',
  fullWidth,
  helperText = '',
  inputProps,
  label,
  isLoading,
  placeholder,
  autoFocus = false,
}) => {
  const { formatMessage } = useIntl();

  const classes = useStyles({});

  const { inputRef, ...toPass } = inputProps || {};
  return (
    <Box className={classes.root} fullWidth>
      <TextField
        // eslint-disable-next-line jsx-a11y/no-autofocus
        autoFocus={autoFocus}
        className={fullWidth && classes.input}
        disabled={disabled}
        errorMessage={errorMessage}
        fullWidth={fullWidth}
        hasError={!!errorMessage}
        helpMessage={helperText || null}
        label={label}
        placeholder={placeholder || formatMessage(messages.placeholder)}
        aria-label={label || placeholder || formatMessage(messages.placeholder)}
        {...toPass}
      />
      {isLoading && (
        <span
          className={clsx(classes.loader, label && classes.loaderWithLabel)}
        >
          <DotLoader size={0} />
        </span>
      )}
    </Box>
  );
};
